(function () {
  if (innerWidth > 749) return;
  var cfg = window.N1M2 || {}, ar = !!cfg.ar;
  function start() {
    var c = document.body.classList;
    if (c.contains('template-product')) {
      document.addEventListener('click', function (e) {
        if (e.target.closest('.n1m-tb--p .n1m-tb__back')) { e.preventDefault(); e.stopImmediatePropagation(); location.href = cfg.root || '/'; }
      }, true);
      var acc = document.querySelector('.n1-pdp .n1-acc');
      if (acc) {
        var ds = [].slice.call(acc.querySelectorAll('details'));
        ds.forEach(function (d) {
          if (/الشحن|الاسترجاع|Shipping|Returns/i.test(d.querySelector('summary').textContent)) d.remove(); else d.removeAttribute('open');
        });
        var body = acc.querySelector('details .rte');
        if (body) {
          var re = /^\s*(طريقة الاستعمال|طريقة الاستخدام|كيفية الاستخدام|الاستخدام|how to use|directions|usage)\s*:?\s*$/i;
          var kids = [].slice.call(body.children), at = -1;
          kids.forEach(function (k, i) { if (at < 0 && re.test(k.textContent)) at = i; });
          if (at > -1) {
            var d = document.createElement('details'), first = acc.querySelector('details');
            d.innerHTML = '<summary>' + (ar ? 'طريقة الاستعمال' : 'How to use') + first.querySelector('summary svg').outerHTML + '</summary><div class="n1-acc__body rte"></div>';
            var box = d.querySelector('.rte');
            kids[at].remove();
            for (var i = at + 1; i < kids.length; i++) {
              var k = kids[i];
              if (/^H[1-6]$/.test(k.tagName) || (k.tagName === 'P' && k.children.length === 1 && k.firstElementChild.tagName === 'STRONG' && k.textContent.trim() === k.firstElementChild.textContent.trim())) break;
              box.appendChild(k);
            }
            if (box.children.length) first.insertAdjacentElement('afterend', d);
          }
        }
      }
    }
    if (c.contains('template-index')) {
      var on = false;
      var f = function () { var s = scrollY > 60; if (s !== on) { on = s; c.toggle('n1m-stuck', s); } };
      addEventListener('scroll', f, { passive: true }); f();
      var seen = window.__n1seen || {};
      document.querySelectorAll('[id$="__rail_perf"] [data-ksx-pid]').forEach(function (e) { if (seen[e.getAttribute('data-ksx-pid')]) e.remove(); });
    }
    var s = document.querySelector('.n1m-cats__search');
    if (s) s.onclick = function () {
      var t = document.querySelector('.ksx-tabbar [data-n1m-cats]'), q = document.querySelector('[data-n1-q]');
      if (t) t.click();
      if (q) q.focus();
    };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
